/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Alipay_DescriptionInputs */

const en_admin_settings_groups_alipay_description = /** @type {(inputs: Admin_Settings_Groups_Alipay_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alipay payment gateway (native)`)
};

const zh_admin_settings_groups_alipay_description = /** @type {(inputs: Admin_Settings_Groups_Alipay_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付宝支付（原生）`)
};

/**
* | output |
* | --- |
* | "Alipay payment gateway (native)" |
*
* @param {Admin_Settings_Groups_Alipay_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_alipay_description = /** @type {((inputs?: Admin_Settings_Groups_Alipay_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Alipay_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_alipay_description(inputs)
	return zh_admin_settings_groups_alipay_description(inputs)
});
export { admin_settings_groups_alipay_description as "admin.settings.groups.alipay.description" }